import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const Surveys = lazy(() =>
  componentLoader(() => import("./components/Surveys")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <Surveys />
      </section>
    </Suspense>
  </div>
);
